var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.576 19.488h7.876a.577.577 0 0 0 .576-.576v-6.477c0-.247-.2-.435-.435-.435H8.36c-.248 0-.436.2-.436.435v4.925H3.15v-4.925c.001-.247-.199-.435-.434-.435h-1.27a.444.444 0 0 0-.446.435v6.477c0 .318.259.576.576.576zm17.375.012h1.27c.235 0 .423-.2.412-.435v-6.442a.582.582 0 0 0-.905-.47l-3.504 2.41a.406.406 0 0 1-.482 0l-3.502-2.41a.516.516 0 0 0-.317-.106.577.577 0 0 0-.575.576v6.442c0 .247.2.435.435.435h1.258c.247 0 .435-.2.435-.435v-3.339l2.21 1.388a.574.574 0 0 0 .61 0l2.223-1.388v3.34c0 .246.2.434.435.434zm3.598-7.5h7.876c.317 0 .576.259.576.576v6.477a.432.432 0 0 1-.423.435h-1.27a.434.434 0 0 1-.435-.435V14.41a.286.286 0 0 0-.282-.282h-4.197a.286.286 0 0 0-.282.282v4.643a.434.434 0 0 1-.434.435h-1.27a.434.434 0 0 1-.434-.435v-6.477c0-.317.258-.576.576-.576zm4.56 3.491h-1.257a.432.432 0 0 0-.434.425v1.293c0 .247.2.435.435.435h1.259c.246 0 .434-.2.434-.435v-1.282c0-.247-.2-.435-.435-.435z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUma);
export default __webpack_public_path__ + "static/media/UMA.6489e1fbb1d2f040c59ed0b3e64e7c53.svg";
export { ForwardRef as ReactComponent };